import { ChevronLeftIcon } from './icons';
import './AppHeader.css';

export default function AppHeader({ onBack }) {
  if (!onBack) return null;

  return (
    <header className="app-header">
      <button type="button" className="app-header__back" onClick={onBack} aria-label="Back">
        <ChevronLeftIcon size={20} />
      </button>
    </header>
  );
}